export enum Currency {
    USD = 'USD',
    EUR = 'EUR',
    CHF = 'CHF'
}